import { useQuery } from '@tanstack/react-query';
import { OrganizationService } from '@/infra/services/organization';
import { QUERY_KEYS } from '@/utils/query-keys';

const Service = OrganizationService.getInstance();

export const useGetListOrganization = () => {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_LIST_ORGANIZATION],
		queryFn: async () => Service.index()
	});
};
